module.exports = "<div class=\"form-group\" [class.has-success]=\"hasSuccess()\" [class.has-error]=\"hasError()\">\n  <label class=\"control-label\" for=\"inputSuccess\"><i class=\"fa\" [class.fa-check]=\"hasSuccess()\"></i>{{label}} </label>\n  <ng-content></ng-content>\n  <span class=\"help-block\" *ngIf=\"hasSuccess()\"><i class=\"fa fa-check\"></i> Ok</span>\n  <span class=\"help-block\" *ngIf=\"hasError()\"><i class=\"fa fa-remove\"></i> {{errorMessage}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/input/input.component.html
// module id = 380
// module chunks = 2